export default "__VITE_ASSET__e546b0bd__"